import { render, staticRenderFns } from "./SdkRecipients_4_2.vue?vue&type=template&id=5b80f94b"
import script from "./SdkRecipients_4_2.vue?vue&type=script&lang=js"
export * from "./SdkRecipients_4_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports